import { Component, Injector, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Validators } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AcaoService } from '../../acao/service/acao.service';
import { AcaoFonteRecursoService } from '../service/acao-fonte-recurso.service';
import { takeUntil } from 'rxjs/operators';
import { Acao, AcaoFonteRecurso, AcaoGoverno, Auditoria, AuditoriaService, BaseResourceFormComponent, EddyAutoComplete, Executora, ExecutoraService, FuncaoGoverno, FuncaoService, GlobalService, Indicador, LoginContabil, MetaGoverno } from 'eddydata-lib';
import { MetaGovernoService, AcaoGovernoService, FuncaoGovernoService, IndicadorService } from 'administrativo-lib';
import * as toastr from 'toastr';
import { IndicadorAdicionalService } from 'projects/administrativo-lib/src/lib/planejamento/meta-governo/service/indicador-adicional.service';
import { IndicadorAdicional } from 'projects/eddydata-lib/src/lib/entidade/planejamento/indicador-adicional.model';
import { TreeNode } from 'pdf-lib/cjs/core/structures/PDFPageTree';

declare var $: any;

@Component({
  selector: 'app-acao-governo-form',
  templateUrl: './acao-governo-form.component.html'
})
export class AcaoGovernoFormComponent extends BaseResourceFormComponent<AcaoGoverno, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  @ViewChild('tipo_') inputField: ElementRef;
  @ViewChild('btnAdicionarIndicador') public btnAdicionarIndicador: ElementRef;
  @ViewChildren('btnsEditar') public btnsEditar: QueryList<ElementRef>;

  public listaTipos: Array<any>;
  public listaAcoesRecurso = new Array<AcaoFonteRecurso>();
  public acaoAutoComplete: EddyAutoComplete<Acao>;
  public executoraAutoComplete: EddyAutoComplete<Executora>;
  public metaAutoComplete: EddyAutoComplete<MetaGoverno>;
  public totalCustoAnual: number;
  public totalCustoDetalhado: number;
  public anoCorrente: number;
  public indicadorAdicional: IndicadorAdicional;
  public listaIndicadoresAdicionais = new Array<IndicadorAdicional>();
  public listaIndicadores = new Array<IndicadorAdicional>();
  indicador: Indicador = new Indicador();
  meta1: number = 0;
  meta2: number = 0;
  meta3: number = 0;
  meta4: number = 0;
  unidade_medida: string;
  public funcaoAutoComplete: EddyAutoComplete<FuncaoGoverno>;
  public subFuncaoAutoComplete: EddyAutoComplete<FuncaoGoverno>;
  public listaHistorico: Auditoria[] = [];
  public historicoSelecionado: Auditoria;
  
  arvore_alteracoes: TreeNode[] = [];
  selectGalho: any;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected confirmationService: ConfirmationService,
    protected messageService: MessageService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected metaService: MetaGovernoService,
    protected acaoRecursoService: AcaoFonteRecursoService,
    protected acService: AcaoService,
    protected executoraService: ExecutoraService,
    protected acaoService: AcaoGovernoService,
    protected funcaoGovernoService: FuncaoGovernoService,
    protected indicadorAdicionalService: IndicadorAdicionalService,
    private auditoriaService: AuditoriaService
  ) {
    super(new AcaoGoverno(), injector, AcaoGoverno.converteJson, acaoService);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      aux: [0, [Validators.required]],
      tipo: ['I', [Validators.required]],
      custo1: [null, [Validators.required]],
      custo2: [null, [Validators.required]],
      custo3: [null, [Validators.required]],
      custo4: [null, [Validators.required]],
      meta1: [null],
      meta2: [null],
      meta3: [null],
      meta4: [null],
      acao: [null, [Validators.required]],
      meta_acao: [null, [Validators.required]],
      unidade_medida: [null, [Validators.required]],
      executora: [null, [Validators.required]],
      meta: [null, [Validators.required]],
      indicador: [null],
      ppa: [this.login.ppa, [Validators.required]],
      acoes_recurso: [],
      enviado_tce: [null],
      funcao: [null],
      subfuncao: [null],
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'acao,executora,meta,meta.programa,meta.funcao,meta.subfuncao,meta.indicadores,indicador,funcao,subfuncao' };
  }

  protected afterLoad() {
    this.acaoRecursoService.filtrar(0, -1, {
      acao_governo_id: this.entidade.id, ano: this.login.exercicio.ano,
      relations: 'recurso,aplicacao,despesa'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaAcoesRecurso = res.content ? res.content : new Array<AcaoFonteRecurso>();
      });

    this.indicadorAdicionalService.filtrar(0, -1, {
      acao_governo_id: this.entidade.id,
      relations: 'acao_governo,indicador'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaIndicadoresAdicionais = res.content ? res.content : new Array<IndicadorAdicional>();

        if (this.entidade.meta?.indicadores?.length > 0) {
          this.preencherListaIndicadores();
        }
      });

    if (!this.entidade.funcao) {
      this.entidade.funcao = this.entidade.meta.funcao;
      this.entidadeForm.get('funcao').setValue(this.entidade.meta.funcao);
    }

    if (!this.entidade.subfuncao) {
      this.entidade.subfuncao = this.entidade.meta.subfuncao;
      this.entidadeForm.get('subfuncao').setValue(this.entidade.meta.subfuncao);
    }

  }

  protected afterInit(): void {
    this.listaTipos = this.globalService.obterListaTiposPpa();
    this.listaTipos.push({ id: 'N', nome: 'INCLUSÃO' });
    this.carregarAutoCompletes();
  }

  protected campoFoco(): ElementRef {
    return this.inputField;
  }

  public mudarMetas(indicador: Indicador) {
    this.indicador = this.entidadeForm.get('indicador').value;

    if (!this.login.planejamento_manual) {
      this.entidade.meta1 = this.indicador.meta1;
      this.entidade.meta2 = this.indicador.meta2;
      this.entidade.meta3 = this.indicador.meta3;
      this.entidade.meta4 = this.indicador.meta4;
    }
  }

  protected beforeSubmit() {
    try {
      if (!this.entidadeForm.get('meta_acao').value) {
        throw new Error('Informe o alvo');
      }
      if (!this.entidadeForm.get('acao').value) {
        throw new Error('Informe a ação de governo');
      }
      if (!this.entidadeForm.get('meta').value) {
        throw new Error('Informe a meta');
      }
      if (!this.entidadeForm.get('tipo').value) {
        throw new Error('Informe o tipo da ação');
      }
      if (!(this.entidadeForm.get('meta').value instanceof Object)) {
        throw new Error('Selecione um programa de governo válido');
      }
      if (!(this.entidadeForm.get('acao').value instanceof Object)) {
        throw new Error('Selecione uma ação de governo válida');
      }
      if ((+(+this.totalCustoDetalhado).toFixed(2) - +this.totalCustoAnual) !== 0 && +this.totalCustoDetalhado !== 0) {
        throw new Error('O total detalhado não confere com o custo total para o ano!');
      }

      this.entidadeForm.get('acoes_recurso').setValue(this.listaAcoesRecurso);
      this.entidadeForm.get('indicador').patchValue(this.indicador)
      this.entidadeForm.get('unidade_medida').setValue(this.entidade.unidade_medida);
      this.entidadeForm.get('meta1').setValue(this.entidade.meta1)
      this.entidadeForm.get('meta2').setValue(this.entidade.meta2)
      this.entidadeForm.get('meta3').setValue(this.entidade.meta3)
      this.entidadeForm.get('meta4').setValue(this.entidade.meta4)
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  protected afterSubmit(ent: AcaoGoverno) {
    this.acaoRecursoService.filtrar(0, -1, {
      acao_governo_id: this.entidade.id, ano: this.anoCorrente ?? this.login.exercicio.ano,
      relations: 'recurso,aplicacao,despesa'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaAcoesRecurso = res.content ? res.content : new Array<AcaoFonteRecurso>();
      });
    if (this.limparTela) {
      this.entidadeForm.reset();
      this.entidadeForm.get('aux').setValue(0);
      this.entidadeForm.get('tipo').setValue('I');
      this.entidadeForm.get('ppa').setValue(this.login.ppa);
      this.router.navigate(['/acoes-governo', 'novo']);
    }
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public atualizaIndicePPA(soma: any) {
    this.totalCustoAnual = soma.custo_anual;
    this.totalCustoDetalhado = soma.total_detalhado;
  }

  public atualizarLista(lista: any) {
    this.listaAcoesRecurso = lista;
  }

  public atualizarAnoCorrente(ano: any) {
    this.anoCorrente = +ano;
  }

  public async existeAcao() {
    var acaoPreenchida = this.entidadeForm.get('acao') && this.entidadeForm.get('acao')?.value ? this.entidadeForm.get('acao').value : null

    if (acaoPreenchida && !isNaN(+(acaoPreenchida?.split(' ')[0]))) {
      const acao = await this.acService.obter(
        {
          codigo: acaoPreenchida.split(' ')[0],
          ppa_id: this.login.ppa.id
        }
      ).pipe(takeUntil(this.unsubscribe)).toPromise();

      if (!acao) {
        this.confirmationService.confirm({
          message: 'A ação informada não está cadastrada. Deseja cadastrá-la?',
          header: 'Cadastro',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: () => {
            $('#dialogAcao').modal('show');
          },
          reject: () => {
            this.entidadeForm.get('acao').reset();
          }
        });
      } else {
        this.entidadeForm.get('acao').setValue(acao);
      }
    }
  }

  public updateAcao(event: any) {
    this.entidadeForm.get('acao').setValue(JSON.parse(JSON.stringify(event)).event);
  }

  private carregarAutoCompletes() {
    // autocomplete para acao
    this.acaoAutoComplete = new EddyAutoComplete(this.entidadeForm.get('acao'), this.acService,
      'id', ['codigo', 'nome'], { ppa_id: this.login.ppa.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );

    // autocomplete para executora
    this.executoraAutoComplete = new EddyAutoComplete(this.entidadeForm.get('executora'), this.executoraService,
      'id', ['codigo', 'nome'], { 'unidade.ppa_id': this.login.ppa.id, orderBy: 'nome' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );

    // autocomplete para meta
    this.metaAutoComplete = new EddyAutoComplete(this.entidadeForm.get('meta'), this.metaService,
      'id', ['programa.codigo', 'programa.nome'],
      { ppa_id: this.login.ppa.id, relations: 'funcao,subfuncao,indicadores', orderBy: 'programa.nome,indicadores.codigo' },
      { number: ['programa.codigo'], text: ['programa.nome'] },
      () => {
        const programa = this.entidadeForm.get('meta').value;

        this.entidadeForm.get('funcao').setValue(programa?.funcao);
        this.entidade.funcao = programa?.funcao;

        this.entidadeForm.get('subfuncao').setValue(programa?.subfuncao);
        this.entidade.subfuncao = programa?.subfuncao;
      }
    );

    // autocomplete para funcao governo
    this.funcaoAutoComplete = new EddyAutoComplete(null, this.funcaoGovernoService,
      'id', ['codigo', 'nome'], { nivel: 0, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );

    // autocomplete para subfuncao governo
    this.subFuncaoAutoComplete = new EddyAutoComplete(null, this.funcaoGovernoService,
      'id', ['codigo', 'nome'], { nivel: 1, cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome'] }
    );
  }

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
        this.router.navigate(['/planejamento']);
        break;
      default:
        this.sair();
        break;
    }
  }

  private desabilitarEdicao(acao: boolean) {
    this.btnsEditar.forEach((btn) => btn.nativeElement.disabled = acao)
    this.btnAdicionarIndicador.nativeElement.disabled = acao;
  }

  public async adicionarIndicador() {
    this.indicadorAdicional = new IndicadorAdicional();
    this.indicadorAdicional['editavel'] = true;
    this.indicadorAdicional['salvo'] = false;
    if (!this.listaIndicadoresAdicionais) {
      this.listaIndicadoresAdicionais = new Array();
    }
    this.listaIndicadoresAdicionais.unshift(this.indicadorAdicional);
    this.desabilitarEdicao(true)
  }

  public salvarIndicador(item: IndicadorAdicional, index: number) {
    try {
      item['editavel'] = false;
      item['salvo'] = true;
      item.acao_governo = this.entidade;

      this.indicadorAdicionalService.inserir(item).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          item = res;
          this.listaIndicadoresAdicionais = this.listaIndicadoresAdicionais.map(it => {
            if (it.indicador?.id === item.indicador?.id) {
              return {
                ...it,
                id: item.id
              };
            }
            return it;
          });

          toastr.success('Indicador adicional incluído com sucesso!');
        }, (e) => {
          toastr.error('Falha ao incluir indicador adicional, ' + (e.error?.erro ? e.error.erro : e.error?.payload ? e.error.payload : JSON.stringify(e)));
        });
      this.preencherListaIndicadores();
      this.desabilitarEdicao(false);
    } catch (e) {
      this.messageService.add({ severity: 'error', summary: 'Validação', detail: e });
      throw e;
    }
  }

  public cancelarIndicador(item: IndicadorAdicional, index: number) {
    if (item['salvo'] && item.id === this.indicadorAdicional?.id) {
      this.indicadorAdicional = item;
      this.indicadorAdicional['editavel'] = false;
    } else {
      this.listaIndicadoresAdicionais.splice(index, 1);
    }
    this.desabilitarEdicao(false);
  }

  public removerIndicador(item: IndicadorAdicional, index: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja desvincular o item?',
      acceptLabel: "Sim",
      rejectLabel: "Não",
      header: 'Remoção',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.removerItem(item, index);
      },
    });
  }

  private removerItem(item: IndicadorAdicional, index: number) {
    if (item.id) {
      if (this.login.usuario.administrador && this.login.usuario.sistemas_administrador?.includes('contabil')) {
        this.indicadorAdicionalService.remover(item.id).subscribe(() => {
          item['editavel'] = false;
          this.listaIndicadoresAdicionais.splice(index, 1);
          toastr.success('Indicador adicional removido com sucesso!');

          this.preencherListaIndicadores();
        }, (e) => {
          toastr.error('Falha ao remover indicador adicional, ' + (e.error?.erro ? e.error.erro : e.error?.payload ? e.error.payload : JSON.stringify(e)));
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Exclusão', detail: 'Operação não permita, por gentileza verificar com o administrador!' });
      }
    }
  }

  public preencherListaIndicadores() {
    const idsAdicionais = new Set(
      this.listaIndicadoresAdicionais?.map(i => i.indicador.id)
    );

    this.listaIndicadores = this.entidade.meta.indicadores.filter(i =>
      i.id !== this.entidade?.indicador?.id &&
      !idsAdicionais.has(i.id)
    );
  }

  public editarIndicador(item: IndicadorAdicional) {
    this.indicadorAdicional = item;
    this.indicadorAdicional['editavel'] = true;
    this.indicadorAdicional['salvo'] = false;
    this.desabilitarEdicao(true)
  }

  carregarHistoricoDeAuditoria() {
      this.auditoriaService.filtrar(1, -1, { relations: 'usuario','alvo$like': 'AcaoGoverno', 'alvo_id': this.entidade.id, 'orderBy': 'id$DESC' }).pipe(takeUntil(this.unsubscribe))
        .subscribe(
          lista => {
            this.listaHistorico = lista.content;
          },
          (erro) => {
            console.error('Erro ao retornar lista de histórico:', erro);
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar histórico' });
          }
        );
    }
    abrirModal(item: Auditoria) {
      this.historicoSelecionado = item;
      this.arvore_alteracoes = [];
      let arvore: TreeNode[] = [];
  
      if (item.antes)
        arvore = this.gerarArvore(item.antes, arvore, true);
      if (item.depois)
        arvore = this.gerarArvore(item.depois, arvore, false);
  
      this.selectGalho = <any>{
        label: item.alvo,
        data: {
          antes: item.antes,
        },
        expandedIcon: 'fa fa-sitemap',
        collapsedIcon: 'fa fa-sitemap',
        children: arvore,
        expanded: true
      };
      this.arvore_alteracoes = [this.selectGalho];
      
      $('#modalHistoricoAuditoria').modal('show');
    }
  
    fecharModal() {
      this.arvore_alteracoes = [];
      $('#modalHistoricoAuditoria').modal('hide');
    }
  
    nodeSelectEvent(event?) {
      this.selectGalho.expanded = true;
      window.scroll(0, 0);
    }
  
    nodeSelect(tree) {
      this.selectGalho = tree;
      this.nodeSelectEvent(event);
    }
  
    gerarArvore(estrutura: any, arvore: any[], antes?: boolean, corCallback?: Function): any[] {
      for (let [key, value] of Object.entries(estrutura)) {
        let galho;
        let valid = arvore.find((t) => t.label === key);
        if (valid)
          galho = valid;
        else
          galho = {
            label: key,
            data: { antes: null, depois: null },
            expandedIcon: 'fa fa-database',
            collapsedIcon: 'fa fa-database',
            children: []
          };
        if (antes)
          galho.data.antes = value;
        else
          galho.data.depois = value;
        if (value && typeof value === 'object') {
          galho.collapsedIcon = 'fa fa-sitemap';
          galho.expandedIcon = 'fa fa-sitemap';
          galho.children = this.gerarArvore(value, galho.children, antes, () => {
            galho.styleClass = 'text-danger'
          });
        }
        if (!valid)
          arvore.push(galho);
      }
      return arvore;
    }
}
